import { render } from "./FaciltyProfileTab.vue?vue&type=template&id=3fc07a7e&scoped=true"
import script from "./FaciltyProfileTab.vue?vue&type=script&lang=js"
export * from "./FaciltyProfileTab.vue?vue&type=script&lang=js"

import "./FaciltyProfileTab.vue?vue&type=style&index=0&id=3fc07a7e&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc07a7e"]])

export default __exports__